<app-stations-list-list-station *ngFor="let station of stationList"
    class="station"
    [station]="station">
</app-stations-list-list-station>

<p *ngIf="stationList.length === 0" class="no-station">{{ 'stationsFiltersList.stationsList.stationsListList.noStation' | translate }}</p>
